module.exports = __webpack_public_path__ + "img/downloadFile.f706b43b.svg";